import ReactGA from 'react-ga4';

export function initGA(): void {
  const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

  if (GA_MEASUREMENT_ID) {
    ReactGA.initialize(GA_MEASUREMENT_ID);
    console.log(`[GA4] Initialized with ID: ${GA_MEASUREMENT_ID}`);
  } else {
    console.warn('[GA4] No GA measurement ID found');
  }
}
